const URBAN_BLACKLIST = [
  "appTLcARVWQKnOVKUyuV", // 49.1886377,20.2321852,
];

const NATURE_BLACKLIST = [
  "11RjNLIwhw0hLWi6m5uh", // 49.1527872,20.0454569,
  "9E8hMCFGrElZsXx65OFR", // 49.215426,19.7294841
  "DKfJKsdNOSl4d1MsQ7io", // 49.2073592,19.7391701
  "DphA9VKOXCC7X4vh8OjE", // 49.1527872,20.0454569
  "ET3C5HM3Jl0pJ6Lua7ki", // 49.2365834,19.7667929
  "FCpySaXDlm242EDmbJdY", // 49.20654589999999,19.933708
  "IpUflOjrexI6gTuEjcJi", // 49.215426,19.7294841
  "QbguzjkNcEZHu9BL2t92", // 49.1873082,19.0829515
  "Sqr5QcnsZFxkxnRougAW", // 49.1873082,19.0829515
  "Xeb7l7H2B9k0WcKOVICB", // 49.15727800000001,20.0955496
  "fLAcAoK5j1buqfwFytkT", // 49.15727800000001,20.0955496
  "gcwbVfukMbC0p3mIkLfZ", // 49.1535602,20.0798558
  "lJswkYleEJQNmVcw6zXI", // 49.2073592,19.7391701
  "onML0eCO5St1iQmGwozw", // 49.15727800000001,20.0955496
  "tglOBCQyb5zAp2o735Ph", // 49.2073592,19.7391701
  "ugrBOGkVNMZua1SafRv6", // 49.20654589999999,19.933708
  "wHkWjeqqMHTQyJnecrqC", // 49.1535602,20.0798558
  "11RjNLIwhw0hLWi6m5uh", // 49.1527872,20.0454569
  "9E8hMCFGrElZsXx65OFR", // 49.215426,19.7294841
  "DKfJKsdNOSl4d1MsQ7io", // 49.2073592,19.7391701
  "DphA9VKOXCC7X4vh8OjE", // 49.1527872,20.0454569
  "ET3C5HM3Jl0pJ6Lua7ki", // 49.2365834,19.7667929
  "FCpySaXDlm242EDmbJdY", // 49.20654589999999,19.933708
  "IpUflOjrexI6gTuEjcJi", // 49.215426,19.7294841
  "QbguzjkNcEZHu9BL2t92", // 49.1873082,19.0829515
  "Sqr5QcnsZFxkxnRougAW", // 49.1873082,19.0829515
  "Xeb7l7H2B9k0WcKOVICB", // 49.15727800000001,20.0955496
  "YrMk3wDvD6ECg4xXDvKi", // 49.1886377,20.2321852
  "fLAcAoK5j1buqfwFytkT", // 49.15727800000001,20.0955496
  "gcwbVfukMbC0p3mIkLfZ", // 49.1535602,20.0798558
  "lJswkYleEJQNmVcw6zXI", // 49.2073592,19.7391701
  "onML0eCO5St1iQmGwozw", // 49.15727800000001,20.0955496
  "tglOBCQyb5zAp2o735Ph", // 49.2073592,19.7391701
  "ugrBOGkVNMZua1SafRv6", // 49.20654589999999,19.933708
  "wHkWjeqqMHTQyJnecrqC", // 49.1535602,20.0798558
  "yj91vKA3hlDMXhVjk0hz", // 49.1886377,20.2321852

  // Waterfalls
  "2B9EzCzHruKhs47n6klD", // 49.1873082,19.0829515
  "CWPFRYVdA6ptZoi6JQ4e", // 49.2073592,19.7391701
  "0xo2pXwkpX7GpN4G7cnY", // 49.1528086,20.0452262
  "1XX8Scs96aA6NMGSmcfT", // 49.215426,19.7294841

  // Urban
  "GMWH8JdU5UfwykW2Z4P1", // 49.1885894,20.2300657
  "Q61QnqSbHEe97oXnclZn", // 49.1861617,19.9958593
  "yh1kZmVoLAslWgGb4ozw", // 49.1495654,20.0389062
];

export const BLACKLIST = [...URBAN_BLACKLIST, ...NATURE_BLACKLIST];

export const getSearchRadiusFor = (duration: number) => {
  switch (true) {
    case duration <= 2:
      return 25;

    case duration > 2 && duration <= 5:
      return 50;

    case duration > 5 && duration <= 16:
      return 120;

    case duration > 16:
      return 150;

    default:
      return 25;
  }
};

export const getNeighborhoodDistanceFor = (duration: number) => {
  switch (true) {
    case duration <= 2:
      return 10;

    case duration > 2 && duration <= 5:
      return 1;

    case duration > 5 && duration <= 16:
      return 1;

    case duration > 16:
      return 1;

    default:
      return 10;
  }
};
